import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import "../styles/clients.css";
import JSZip from "jszip";
import JSZipUtils from "jszip-utils";
import saveAs from "save-as";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import PDFMerger from "pdf-merger-js";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";

const MySwal = withReactContent(Swal2);

const UndevDeliveriesArchive = (props) => {
  const [deliveries, setDeliveries] = useState([]);
  const [deliveriesFiles, setDeliveriesFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [expand, setExpand] = useState("");
  const [expandYear, setExpandYear] = useState(new Date().getFullYear());
  const [expandMonth, setExpandMonth] = useState("");

  const [loading, setLoading] = useState(false);

  const fetchDev = async () => {
    await fetch("https://apidevkppp.ftpeople.pl/getAllDeliveries", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        var arr = [];
        var years = [];
        var months = [];
        data.map((el) => {
          var year = new Date(
            JSON.parse(el.value).publicationDate
          ).getFullYear();
          if (years.filter((ex) => ex === year).length === 0) {
            years.push(year);
          }
          var month =
            new Date(JSON.parse(el.value).publicationDate).getMonth() + 1;
          if (months.filter((ex) => ex === month).length === 0) {
            months.push(month);
          }
          arr.push(el);
        });
        setYears(
          years.sort(function compareNumbers(a, b) {
            return b - a;
          })
        );
        setMonths(
          months.sort(function compareNumbers(a, b) {
            return b - a;
          })
        );
        setDeliveries(arr);
        fetchDevFiles();
      })
      .catch((error) => {});
  };

  const fetchDevFiles = async () => {
    await fetch("https://apidevkppp.ftpeople.pl/getAllDeliveriesFiles", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        setDeliveriesFiles(data);
        fetchFiles();
      })
      .catch((error) => {});
  };

  const fetchFiles = async () => {
    await fetch("https://apidevkppp.ftpeople.pl/getFiles", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
    })
      .then((response) => response.json())
      .then(async (data) => {
        setFiles(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchDev();
  };

  const getMonthName = (month) => {
    switch (month) {
      case 1:
        return "Styczeń";
      case 2:
        return "Luty";
      case 3:
        return "Marzec";
      case 4:
        return "Kwiecień";
      case 5:
        return "Maj";
      case 6:
        return "Czerwiec";
      case 7:
        return "Lipiec";
      case 8:
        return "Sierpień";
      case 9:
        return "Wrzesień";
      case 10:
        return "Październik";
      case 11:
        return "Listopad";
      case 12:
        return "Grudzień";
      default:
        return "Styczeń";
    }
  };

  useEffect(() => {
    getData();
  }, []);

  async function addWatermark(pdfBytes, watermarkText) {
    const pdfDoc = await PDFDocument.load(pdfBytes);
    const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    const pages = pdfDoc.getPages();

    pages.forEach((page) => {
      const { width, height } = page.getSize();

      // Ustawienia watermark
      const fontSize = 16;
      const opacity = 0.5;
      const rotation = Math.atan2(height, width);

      // Rysowanie tekstu w centrum strony, po przekątnej
      page.drawText(watermarkText, {
        x: 5,
        y: 5,
        size: fontSize,
        font,
        color: rgb(0.75, 0.75, 0.75),
        opacity,
        rotate: { type: "degrees", angle: 0 },
      });
    });

    const modifiedPdfBytes = await pdfDoc.save();
    return modifiedPdfBytes;
  }

  function blobToArrayBuffer(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(blob);
    });
  }

  const getDevsMulti = async () => {
    setLoading(true);
    var arr = [];

    chooseDev.map((el) => {
      arr.push({
        id: el,
        link: deliveries.filter((p) => +p.devId === +el)[0].link,
      });
    });
    var body = {
      devs: arr,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getDevsMulti", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        const zip = new JSZip();

        var count = 0;
        var merger = new PDFMerger();
        var urls = [];
        data.forEach(async function (file) {
          var filename = file.name + "." + file.url.split(".").pop();
          urls.push(file.url);
        });
        urls.map(async (url, index) => {
          console.log(url);
          const data = await fetch(url);
          const blob = await data.blob();
          blobToArrayBuffer(blob).then(async (arrayBuffer) => {
            const byteArray = new Uint8Array(arrayBuffer);

            var date =
              new Date().getFullYear() +
              "-" +
              (new Date().getMonth() + 1 < 10
                ? "0" + (new Date().getMonth() + 1)
                : new Date().getMonth() + 1) +
              "-" +
              (new Date().getDate() < 10
                ? "0" + new Date().getDate()
                : new Date().getDate()) +
              " " +
              (new Date().getHours() < 10
                ? "0" + new Date().getHours()
                : new Date().getHours()) +
              ":" +
              (new Date().getMinutes() < 10
                ? "0" + new Date().getMinutes()
                : new Date().getMinutes());

            const watermark = await addWatermark(
              byteArray,
              "Odebrano dnia " + date
            );

            await merger.add(new Blob([watermark])).then(async () => {
              if (index + 1 === urls.length) {
                await merger.setMetadata({
                  producer: "KPPP WORKFLOW",
                  author: "Admin KPPP",
                  creator: "PI",
                  title: "Odebrane doręczenia",
                });

                fetch("https://apidevkppp.ftpeople.pl/getUndevDeliveries", {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                })
                  .then((response) => response.text())
                  .then(async (data) => {
                    setTimeout(async () => {
                      await merger.save("odebrane " + new Date() + ".pdf");
                      getData();
                    }, 30000);
                  });
              }
            });
          });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getDevsMultiOnce = async (data) => {
    setLoading(true);
    var arr = [];

    data.map((el) => {
      arr.push({
        id: el.id,
        link: el.link,
      });
    });
    var body = {
      devs: arr,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getDevsMulti", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        const zip = new JSZip();

        var count = 0;

        data.forEach(function (file) {
          var filename = file.name + "." + file.url.split(".").pop();
          // loading a file and add it in a zip file
          JSZipUtils.getBinaryContent(file.url, function (err, dataQ) {
            if (err) {
              console.log(err);
              throw err; // or handle the error
            }
            zip.file(filename, dataQ, { binary: true });
            count++;
            console.log(count);
            console.log(data.length);
            if (count === data.length) {
              zip.generateAsync({ type: "blob" }).then(function (content) {
                saveAs(content, "doreczenia.zip");
                fetch("https://apidevkppp.ftpeople.pl/getUndevDeliveries", {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                })
                  .then((response) => response.text())
                  .then((data) => {
                    setTimeout(() => {
                      getData();
                    }, 30000);
                  });
              });
            }
          });
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const download = async (url, filename, type) => {
    const data = await fetch(url);
    const blob = await data.blob();
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.setAttribute("href", objectUrl);
    link.setAttribute("target", "_blank");
    if (type === "portal") {
      link.setAttribute("download", filename);
    } else {
      link.setAttribute("download", filename);
    }

    link.style.display = "none";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const downloadFilePiDev = (e) => {
    var file = deliveriesFiles.filter((el) => +el.docId === +e.target.value)[0];
    download(
      file.link,
      files.filter((ek) => ek.link === file.link)[0].name,
      files.filter((ek) => ek.link === file.link)[0].type
    );
  };

  const devData = (
    <>
      <table className="clients_table">
        <tr key={0}>
          <th>ID</th>
          <th>Id klienta</th>
          <th>Klient</th>
          <th>Sąd</th>
          <th>Sygnatura</th>
          <th>Data</th>
          <th>Identyfikator</th>
          <th>Akcja</th>
        </tr>
        {deliveries
          .filter(
            (ep) =>
              new Date(JSON.parse(ep.value).publicationDate).getFullYear() ===
                expandYear &&
              new Date(JSON.parse(ep.value).publicationDate).getMonth() + 1 ===
                expandMonth
          )
          .map((d, index) => (
            <>
              <tr>
                <td>{index + 1}</td>
                <td>{d.dclientId}</td>
                <td>{d.petitioner}</td>
                <td>{JSON.parse(d.value).court}</td>
                <td>{JSON.parse(d.value).signature}</td>
                <td>{JSON.parse(d.value).publicationDate.split("T")[0]}</td>
                <td>{JSON.parse(d.value).identifier}</td>
                <td>
                  {" "}
                  <button
                    style={{
                      backgroundColor: "#00bdce",
                      border: "none",
                      color: "white",
                      fontWeight: "600",
                      borderRadius: "15px",
                      fontSize: ".6vw",
                    }}
                    id="clientsFilterButton"
                    className="paymentMenuButton"
                    onClick={() => {
                      if (+expand === +JSON.parse(d.value).id) {
                        setExpand("");
                      } else {
                        setExpand(JSON.parse(d.value).id);
                      }
                    }}
                  >
                    pokaż załączniki
                  </button>
                </td>
              </tr>
              {expand === JSON.parse(d.value).id ? (
                <div
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    width: "30px",
                  }}
                >
                  <table
                    id="detailClientTable"
                    className="clients_table"
                    style={{
                      fontSize: ".8vw",
                    }}
                  >
                    <tr>
                      <th>Nazwa</th>
                      <th>Akcja</th>
                    </tr>

                    {deliveriesFiles
                      .filter((w) => +w.devId === +expand)
                      .map((el) => (
                        <>
                          <tr>
                            <td style={{ padding: "5px" }}>
                              {
                                files.filter((ex) => ex.link === el.link)[0]
                                  .name
                              }
                            </td>
                            <td>
                              <button
                                className="refreshButton"
                                value={el.docId}
                                onClick={downloadFilePiDev}
                              >
                                pokaż
                              </button>
                            </td>
                          </tr>
                        </>
                      ))}
                  </table>
                </div>
              ) : (
                ""
              )}
            </>
          ))}
      </table>
    </>
  );

  const data = (
    <>
      {years.map((year) => (
        <>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <p style={{ fontWeight: "900" }}>{year}</p>{" "}
            {expandYear !== year ? (
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={() => setExpandYear(year)}
              >
                Rozwiń
              </button>
            ) : (
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={() => setExpandYear("")}
              >
                Zwiń
              </button>
            )}
          </div>
          {expandYear === year ? (
            <>
              {months
                .filter(
                  (p) =>
                    deliveries.filter(
                      (o) =>
                        new Date(
                          JSON.parse(o.value).publicationDate
                        ).getFullYear() === expandYear &&
                        new Date(
                          JSON.parse(o.value).publicationDate
                        ).getMonth() +
                          1 ===
                          p
                    ).length > 0
                )
                .map((month) => (
                  <>
                    <br />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <p style={{ fontWeight: "600", width: "15%" }}>
                        {getMonthName(+month).toLocaleUpperCase()} -{" "}
                        {
                          deliveries.filter(
                            (o) =>
                              new Date(
                                JSON.parse(o.value).publicationDate
                              ).getFullYear() === expandYear &&
                              new Date(
                                JSON.parse(o.value).publicationDate
                              ).getMonth() +
                                1 ===
                                month
                          ).length
                        }
                      </p>{" "}
                      {expandMonth !== month ? (
                        <button
                          style={{
                            backgroundColor: "#00bdce",
                            border: "none",
                            color: "white",
                            fontWeight: "600",
                            borderRadius: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          id="clientsFilterButton"
                          className="paymentMenuButton"
                          onClick={() => setExpandMonth(month)}
                        >
                          Rozwiń
                        </button>
                      ) : (
                        <button
                          style={{
                            backgroundColor: "#00bdce",
                            border: "none",
                            color: "white",
                            fontWeight: "600",
                            borderRadius: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          id="clientsFilterButton"
                          className="paymentMenuButton"
                          onClick={() => setExpandMonth("")}
                        >
                          Zwiń
                        </button>
                      )}
                    </div>
                    {expandMonth === month ? <>{devData}</> : ""}
                  </>
                ))}
            </>
          ) : (
            ""
          )}
        </>
      ))}
    </>
  );

  return (
    <>
      {loading ? (
        <LoadingPopup />
      ) : (
        <div
          id="reportC"
          className="mainContainerClients"
          style={{ border: "none" }}
        >
          <>
            <p
              style={{
                fontWeight: "600",
                fontSize: "1.5vw",
                textTransform: "uppercase",
              }}
            >
              Doręczenia archiwalne ({deliveries.length} rekordów)
            </p>

            <>
              <button
                style={{
                  backgroundColor: "#00bdce",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "15px",
                  marginBottom: "20px",
                }}
                id="clientsFilterButton"
                className="paymentMenuButton"
                onClick={() => {
                  getData();
                }}
              >
                odśwież
              </button>
            </>

            <div className="desktopFilters">
              <div className="contentBoxPayments">{data}</div>
            </div>
          </>
        </div>
      )}
    </>
  );
};

export default UndevDeliveriesArchive;
